import { render, staticRenderFns } from "./floatBar.vue?vue&type=template&id=b87327c6&"
import script from "./floatBar.vue?vue&type=script&lang=ts&"
export * from "./floatBar.vue?vue&type=script&lang=ts&"
import style0 from "./floatBar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports